import { apiClient } from '../../../utilities/apiClient';

// Cursor-paginated feed. Returns { items, nextCursor }. Pass back the
// `nextCursor` for the follow-up page; null means we're at the end.
export const fetchFeed = async ({ cursor = null, limit = 24, userCountry } = {}) => {
  const params = { status: 'APPROVED', limit };
  if (cursor) params.cursor = cursor;
  if (userCountry) params.country = userCountry;
  const res = await apiClient.get('/posts', { params });
  return { items: res.data.items ?? [], nextCursor: res.data.nextCursor ?? null };
};
